import React, { useState, useEffect } from 'react'

function Apply_agreement({
  setFee, 
  setAgreementq, 
  setUploadagreenment, 
  setPortal, 
  setDocquiz, 
  setFrontid, 
  setBackid, 
  setPropertyimages,
  uniq
}) {

  const [sub, setSub] = useState(false)
  
  const [faPhone, setPhone] = useState()
  const [alt, setAlt] = useState()
  const [email, setEmail] = useState()
  const [loading, setLoading] = useState(false)

  useEffect(()=>{
    if (faPhone && alt && email) {
      setSub(true)
    } else {
      setSub(false)
    }
  },[faPhone, alt, email])

  const submit = () =>{

    setSub(false)
    setLoading(true)

    const loginData = {
      faPhone: faPhone,
      alt: alt,
      email: email,
      uniq: uniq
     
      };

            // Send data to the PHP backend using fetch
            fetch('https://hosteladventures.site/PHP/Pic_php/Upload_real_Est_form.php', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(loginData)
            })
              .then(response => response.json())
              .then(data => {
                // Handle response from backend (e.g., login success or failure)
                if(data.message=='in')
                {
                  setAgreementq(false)
                  setFrontid(true)
                
                }
             
              })
              .catch(error => {
                console.error('Error:', error);
              });
  }
  return (
    <div className='doc_inner'>
        <div>
        <p className='fill_In'>Fill In!</p>
        <input placeholder='Phone number' onChange={(event) => setPhone(event.target.value)}  />
        <input placeholder='Alternative Phone Number' onChange={(event) => setAlt(event.target.value)}  />
        <input placeholder='Email' onChange={(event) => setEmail(event.target.value)}  />
        {sub?(<div className='submit' onClick={submit}>Submit</div>):('')}
        {loading?(<div className='submit'>Loading...</div>):('')}
        
        </div>
    </div>
  )
}

export default Apply_agreement
